import { FC, Fragment } from 'react';
import { ITalentPets } from 'shared/interfaces/IPets';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { Grid, GridProps } from '@material-ui/core';
import { InfoListProps } from 'shared/interfaces/IInfoList';
import InfoItem from 'components/MyInfo/InfoItem/InfoItem';
import { getAnimalAgeDetails } from 'shared/utils/getAnimalAgeDetails';

type PetListProps = InfoListProps<ITalentPets>;

const PetList: FC<PetListProps> = ({
  dataList,
  loadingDataInfo,
  isSaving,
  isEditing,
  isDeleting,
  selectedEditedItem,
  selectedDeletedItem,
  handleOpenFormModal,
  handleDeleteModal,
  handleViewModal,
  variant = 'list',
}) => {
  const gridSize: GridProps =
    variant === 'list'
      ? {
          xs: 12,
        }
      : {
          xs: 12,
          md: 6,
          lg: 4,
          xl: 3,
        };
  return (
    <Grid container spacing={2} style={{ marginTop: 30 }}>
      {dataList.length || loadingDataInfo?.data ? (
        dataList.map((data, index: number) => (
          <Grid item {...gridSize}>
            <InfoItem
              variant={variant}
              attached_media={data?.attached_media}
              info={[
                {
                  name: '',
                  details: data?.animal,
                },
                {
                  name: 'Breed',
                  details: data?.breed,
                },
                {
                  name: 'Size',
                  details: data?.size,
                },
                {
                  name: 'Age',
                  details: getAnimalAgeDetails({
                    age_in_months: data?.age_in_months,
                    age: data?.age,
                    time_period_type: variant === 'list' ? 'full' : 'short',
                  }),
                },
              ]}
              onEdit={() => handleOpenFormModal('edit', index)}
              onDelete={async () => {
                handleDeleteModal(index);
              }}
              onView={() => handleViewModal(index)}
              isEditing={isEditing && selectedEditedItem === index}
              isDeleting={isDeleting && selectedDeletedItem === index}
            />
          </Grid>
        ))
      ) : (
        <CustomTypography>No Data Available</CustomTypography>
      )}
      {/* Loading state when adding a new car */}
      {isSaving && loadingDataInfo?.data && loadingDataInfo?.data?.length > 0 ? (
        <Grid item {...gridSize}>
          <InfoItem variant={variant} info={loadingDataInfo?.data} isSaving={isSaving} />
        </Grid>
      ) : (
        <Fragment />
      )}
    </Grid>
  );
};

export default PetList;
